/* eslint-disable react/no-unescaped-entities */
import React from 'react';
// import { LazyLoadImage } from 'react-lazy-load-image-component';
// import { useTheme } from '@mui/material/styles';
import Box from '@mui/material/Box';
import Grid from '@mui/material/Grid';
import Typography from '@mui/material/Typography';
import Card from '@mui/material/Card';
// import CardContent from '@mui/material/CardContent';
import Button from '@mui/material/Button';

const mock = [
  {
    
    description:
      'National Space Day',
    href : '/national-space-day-celebration'
 
  },
   {
    
    description:
      'Visit To Indian Institute Of Horticultural Research',
    href : '/indian-institute-of-horticultural-research'
 
  },
   {
    
    description:
      'RD’s Nature Retreat',
    href : '/field-trip-rds-nature-retreat'
 
  },
  
   {
    
    description:
      ' Field Trip To Hampi ',
    href : '/trip-to-hampi-2025'
 
  },
    {
    
    description:
      ' Field Trip To AREA 83 ',
    href : '/trip-to-area83-2025'
 
  },
   {
    
    description:
      ' Field Trip To Model Village ',
    href : '/trip-to-model-village-2025'
 
  },
  {
    
    description:
      ' Field Trip To Big Barn Farm ',
    href : '/field-trip-class-3-2025'
 
  },
  {
    
    description:
      ' Field Trip To Janapada Loka and Toy Factory  ',
    href : '/field-trip-class-6-2025'
 
  },
   {
    
    description:
      ' Field Trip To Mysuru  ',
    href : '/field-trip-class-9-2025'
 
  },
   {
    
    description:
      ' Field Trip To Bannerghatta Zoo and Butterfly Park  ',
    href : '/field-trip-class-4-2025'
 
  },
   {
    
    description:
      ' Field Trip To Bhagyalakshmi Farm  ',
    href : '/field-trip-class-5-2025'
 
  },
   {
    
    description:
      ' Field Trip To Suggee Resort ',
    href : '/field-trip-class-7-2025'
 
  },
   {
    
    description:
      ' Field Trip To Infantry Vama',
    href : '/field-trip-class-8-2025'
 
  },
   {
    
    description:
      ' Field Trip To Fire Station',
    href : '/educational-trip-2025'
 
  }, {
    
    description:
      ' Field Trip To Post Office',
    href : '/field-trip-post-office-2025'
 
  },
 { 
    
    description:
      ' National Science Day',
    href : '/national-science-day-2025'
 
  },
 { 
    
    description:
      ' National Centre for Biological Sciences',
    href : '/national-centre-for-biological-science-2025'
 
  },
 { 
    
    description:
      ' Flameless Cooking',
    href : '/flameless-cooking-2025'
 
  },
 { 
    
    description:
      ' Indian Institute of Science',
    href : '/indian-institute-of-science-2025'
 
  },
 { 
    
    description:
      ' Abacus Competition',
    href : '/abacus-competition-2025'
 
  }
  

]

const CoScholacticSidebar2025 = () => {
  
  return (
    <Box component={Card} variant={'outlined'} padding={2}>
      
      <Typography
        variant="h6"
        data-aos={'fade-up'}
        sx={{
          fontWeight: 700,
          marginBottom: 2,
        }}
      >
       Extracurricular Activities 2025-26
      </Typography>
      <Grid container spacing={2}>
        {mock.map((item, i) => (
          <Grid key={i} item xs={12}>
            <Box
              component={Card}
              width={1}
              height={1}
              boxShadow={0}
              borderRadius={0}
              display={'flex'}
              flexDirection={{ xs: 'column', md: 'row' }}
              sx={{ backgroundImage: 'none', bgcolor: 'transparent' }}
            >
              <Button href = {item.href}>
                <Typography component={'h6'}>
                  {item.description}
                </Typography>
              </Button>
            </Box>
          </Grid>
        ))}
      </Grid>
    </Box>
  );
};

export default CoScholacticSidebar2025;
